module.exports = __webpack_public_path__ + "static/media/df (2).5adbf463.jpg";